module.exports = __webpack_public_path__ + "img/63_M5_tsunamis.3744572a.jpg";